import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useActivateAccount } from '../../hooks/useActivateAccount';
import { ActivationLoading, ActivationSuccess, ActivationError, ActivationInvalidToken, AuthHeader } from '../../components/auth';
import LOGO from '../../assets/LOGO (2).png';

const ActivateAccount = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { activate, isPending, isSuccess, isError, error } = useActivateAccount();

  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) return;
    activate(token);
  }, [token, activate]);

  useEffect(() => {
    if (isSuccess && !isPending) {
      const timer = setTimeout(() => {
        navigate('/');
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isSuccess, isPending, navigate]);

  const isLoading = isPending;
  const hasAttempted = isSuccess || isError || error || (!token && token !== null);
  const noToken = !token && hasAttempted && !isError && !error;
  const errorMessage = error?.message || error;

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 to-blue-50 flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <img src={LOGO} alt="Easy Survey" className="h-16 mx-auto mb-4" />
          <h1 className="text-3xl font-bold text-gray-900">Activation du compte</h1>
        </div>

        {/* Contenu */}
        <div className="bg-white rounded-2xl shadow-lg p-8">
          {isLoading && <ActivationLoading />}
          {isSuccess && <ActivationSuccess onNavigate={() => navigate('/')} />}
          {(isError || error) && <ActivationError errorMessage={errorMessage} />}
          {noToken && <ActivationInvalidToken />}
        </div>

        {/* Informations */}
        <div className="mt-6 bg-blue-50 border border-blue-200 rounded-lg p-4">
          <p className="text-sm text-blue-800">
            <strong>Conseil :</strong> Vérifiez votre dossier spam si vous ne recevez pas l'email d'activation.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ActivateAccount;
